var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToastSuccessinline = function SvgToastSuccessinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.675 6.498a.526.526 0 0 0-.38-.165c-.143 0-.28.06-.38.165l-7.219 7.565-2.611-2.74a.554.554 0 0 0-.38-.165.503.503 0 0 0-.381.165.579.579 0 0 0-.158.4.558.558 0 0 0 .158.398l3.372 3.546 7.98-8.37c.1-.107.157-.25.157-.4a.579.579 0 0 0-.158-.399Z",
    fill: "#6FD993",
    stroke: "#6FD993",
    strokeWidth: 0.5
  })));
};

export default SvgToastSuccessinline;